import * as d3 from 'd3'
export default {
  methods: {

    draw_Forms() {

      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.canvasForms
      .append('image')
      .attr('xlink:href', this.HOST + '/WorkOrder/Logo.svg').attr('x', 10).attr('y', 10).attr('width', 230)


      this.canvasTooolBar = this.canvasForms
      .append('g')
      .attr('id', `GROUP_TOOLBAR`)
      .attr('transform', `translate(0, 0)`)

      this.canvasGantt = this.canvasForms
      .append('g')
      .attr('id', `GROUP_GANTT`)
      .attr('transform', `translate(0, 0)`)


      this.draw_Toolbar() 
      
      this.exec_ScheduleChart() 

    },

    exec_ScheduleChart() {
      this.draw_Timeline() 
      this.draw_Header()
      this.draw_Table()
    }


  }
}